import {
  BACK,
  CURRENT_PAGE_FETCHED,
  JUMPED_TO_PAGE,
  NEXT,
} from '../actions/types'

const currentPageReducer = (state = 1, action) => {
  switch (action.type) {
    case NEXT:
      return state + 1
    case BACK:
      return state - 1
    case JUMPED_TO_PAGE:
      return action.payload
    case CURRENT_PAGE_FETCHED:
      return action.payload
    default:
      return state
  }
}

export default currentPageReducer
